const modules = [
  {
    name: 'Affaires',
    apiRequest: '/api/deal/',
    graphQl: 'deals',
    routing: '/dashboard/deal/',
    columns: [
      {
        model: 'name',
        label: 'Nom',
        type: 'text',
        graphQlArgument: 'name',
        graphQlLink: 'name',
      },
      {
        model: 'dateCreate',
        label: 'Date création',
        type: 'date',
        graphQlArgument: 'dateCreate',
        graphQlLink: 'dateCreate',
      },
      {
        model: 'desiredClotureDate',
        label: 'Date cloture désirée',
        type: 'date',
        graphQlArgument: 'desiredClotureDate',
        graphQlLink: 'desiredClotureDate',
      },
      {
        model: 'dateClosed',
        label: 'Date cloture',
        type: 'date',
        graphQlArgument: 'dateClosed',
        graphQlLink: 'dateClosed',
      },
      {
        model: 'domain',
        label: 'Domaine',
        objectLink: 'domain.name',
        apiRequest: '/api/domains/',
        graphQlRequest: '{ domains{id, name} }',
        picklistLabel: 'name',
        dataReturn: 'domains',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'domainIds',
        graphQlLink: 'domain{ name} ',
        noOrderBy: true,
      },
      {
        model: 'lost',
        label: 'Perdue',
        type: 'boolean',
        graphQlArgument: 'lost',
        graphQlLink: 'lost',
        noOrderBy: true,
      },
      {
        model: 'standBy',
        label: 'StandBy',
        type: 'boolean',
        graphQlArgument: 'standBy',
        graphQlLink: 'standBy',
        noOrderBy: true,
      },
      {
        model: 'stepNumber',
        label: 'Gagné',
        type: 'boolean',
        graphQlArgument: 'won',
        graphQlLink: 'stepNumber',
        noOrderBy: true,
        noDisplay: true,
      },
      {
        model: 'stepNumber',
        label: 'Etape',
        type: 'picklist',
        picklistLabel: 'fr',
        multi: false,
        graphQlArgument: 'stepNumber',
        graphQlLink: 'stepNumber',
        dataFile: 'data_deal_step',
        noDisplay: true,
      },
      {
        model: 'customer',
        label: 'Compte',
        routing: '/dashboard/customer/',
        objectLink: 'customer.installationSite.socialReason',
        apiRequest: '/api/searchBar/',
        graphQlSearch: '{ customers(search:$search){ id, installationSite{ socialReason } } }',
        picklistLabel: 'label',
        picklistComposition: ['installationSite', 'socialReason'],
        isSophisticated: true,
        dataReturn: 'customers',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'customersIds',
        graphQlLink: 'customer{ id, installationSite{ socialReason }}',
        noOrderBy: true,
      },
      {
        model: 'type',
        label: "Type d'affaire",
        objectLink: 'type.name',
        apiRequest: '/api/dealType/',
        graphQlRequest: '{ dealTypes{id, name} }',
        picklistLabel: 'name',
        dataReturn: 'dealTypes',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'dealTypeIds',
        graphQlLink: 'type{id, name}',
        noOrderBy: true,
      },
      {
        model: 'origin',
        label: 'Origine',
        objectLink: 'origin.labelOrigin',
        apiRequest: '/api/origin/',
        graphQlRequest: '{ origins{id, labelOrigin} }',
        picklistLabel: 'labelOrigin',
        dataReturn: 'origins',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'originIds',
        graphQlLink: 'origin{ labelOrigin} ',
        noOrderBy: true,
      },
      {
        model: 'reasonOfLoose',
        label: 'Raison de perte',
        objectLink: 'reasonOfLose.wording',
        apiRequest: '/api/stepCommercial/getReasonsOfLoose/',
        graphQlRequest: '{ reasonsOfLoose{ id, wording} }',
        picklistLabel: 'wording',
        dataReturn: 'reasonsOfLoose',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'reasonOfLooseIds',
        graphQlLink: 'reasonOfLoose{ id, wording}',
        noOrderBy: true,
      },
      {
        model: 'creator',
        label: 'Créateur',
        routing: '/dashboard/user/',
        objectLink: 'creator.fullname',
        apiRequest: '/api/employee/',
        graphQlRequest: '{ employees{ id, fullname } }',
        picklistLabel: 'fullname',
        dataReturn: 'employees',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'creatorIds',
        graphQlLink: 'creator{ user{username} }',
        noOrderBy: true,
      },
      {
        model: 'commercialEmployee',
        label: 'Employé en charge',
        routing: '/dashboard/user/',
        objectLink: 'stepCommercial.commercialEmployee',
        apiRequest: '/api/employee/',
        graphQlRequest: '{ employees{ id, fullname } }',
        picklistLabel: 'fullname',
        dataReturn: 'employees',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'commercialEmployeeIds',
        graphQlLink: 'stepCommercial{ commercialEmployee{user{username}} }',
        noOrderBy: true,
      },
      {
        model: 'pdc',
        label: 'PDC',
        objectLink: 'stepCommercial.proposition.pdc',
        type: 'numeric',
        graphQlArgument: 'pdc',
        graphQlLink: 'stepCommercial{proposition{ pdc}}',
        noFilter: true,
        noOrderBy: true,
      },
      {
        model: 'installationDate',
        label: "Date d'installation",
        type: 'date',
        objectLink: 'stepProd.preparation.installation.dateStart',
        graphQlArgument: 'installationDate',
        graphQlLink: 'stepProd{ preparation{ installation{ dateStart}}}',
        noFilter: true,
      },
    ],
  },
  {
    name: 'Comptes',
    apiRequest: '/api/customer/',
    routing: '/dashboard/customer/',
    graphQl: 'customers',
    columns: [
      {
        model: 'installationSite',
        label: 'Raison sociale',
        objectLink: 'installationSite.socialReason',
        type: 'text',
        graphQlArgument: 'socialReason',
        graphQlLink: 'installationSite{ socialReason }',
        noOrderBy: true,
      },
      {
        model: 'professionalField',
        label: 'Domaine professionnel',
        objectLink: 'professionalField.wording',
        type: 'picklist',
        multi: true,
        apiRequest: '/api/customer/profield/',
        graphQlRequest: '{ professionalFields{ id, wording } }',
        picklistLabel: 'wording',
        dataReturn: 'professionalFields',
        graphQlArgument: 'professionalFieldIds',
        graphQlLink: 'professionalField{ wording }',
        noOrderBy: true,
      },
      {
        model: 'dateCreate',
        label: 'Date création',
        type: 'date',
        graphQlArgument: 'dateCreate',
        graphQlLink: 'dateCreate',
      },
      {
        model: 'nearestReminderDate',
        label: 'Date de rappel',
        type: 'date',
        graphQlArgument: 'nearestReminderDate',
        graphQlLink: 'nearestReminderDate',
        noFilter: true,
        noOrderBy: true,
      },
      {
        model: 'termination',
        label: 'Résilié',
        type: 'boolean',
        graphQlArgument: 'termination',
        graphQlLink: 'termination',
        noOrderBy: true,
      },
      {
        model: 'creator',
        label: 'Créateur',
        routing: '/dashboard/user/',
        objectLink: 'creator.fullname',
        apiRequest: '/api/employee/',
        graphQlRequest: '{ employees{ id, fullname } }',
        picklistLabel: 'fullname',
        dataReturn: 'employees',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'creatorIds',
        graphQlLink: 'creator{ user{username} }',
        noOrderBy: true,
      },
      {
        model: 'assignedEmployeeTelecom',
        label: 'Gestionnaire du compte telecom',
        objectLink: 'assignedEmployeeTelecom.fullname',
        apiRequest: '/api/employee/',
        graphQlRequest: '{ employees{ id, fullname } }',
        picklistLabel: 'fullname',
        dataReturn: 'employees',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'assignedEmployeeTelecomIds',
        graphQlLink: 'assignedEmployeeTelecom{ user{username} }',
        noOrderBy: true,
      },
      {
        model: 'assignedEmployeeInformatique',
        label: 'Gestionnaire du compte informatique',
        objectLink: 'assignedEmployeeInformatique.fullname',
        apiRequest: '/api/employee/',
        graphQlRequest: '{ employees{ id, fullname } }',
        picklistLabel: 'fullname',
        dataReturn: 'employees',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'assignedEmployeeInformatiqueIds',
        graphQlLink: 'assignedEmployeeInformatique{ user{username} }',
        noOrderBy: true,
      },
      {
        model: 'triggerContact',
        label: 'Contact',
        routing: '/dashboard/contact/',
        objectLink: 'customer.triggerContact.lastname',
        picklistLabel: 'lastname',
        type: 'picklist',
        multi: true,
        graphQlLink: 'triggerContact{ id, lastname}',
        noFilter: true,
        noOrderBy: true,
      },
      {
        model: 'headOffice',
        label: 'Compte principal',
        routing: '/dashboard/customer/',
        objectLink: 'headOffice.installationSite.socialReason',
        apiRequest: '/api/searchBar/',
        graphQlSearch: '{ customers(search:"$search"){ id, installationSite{ socialReason } } }',
        picklistLabel: 'label',
        picklistComposition: ['installationSite', 'socialReason'],
        isSophisticated: true,
        dataReturn: 'customers',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'headOfficeIds',
        graphQlLink: 'headOffice{id, installationSite{ socialReason }}',
        noOrderBy: true,
      },
      {
        model: 'typeMaintenance',
        label: 'Type de maintenance',
        type: 'text',
        graphQlArgument: 'typeMaintenance',
        graphQlLink: 'typeMaintenance',
        noOrderBy: true,
      },
      {
        model: 'technicalInformation',
        label: 'Infos techniques',
        type: 'text',
        graphQlArgument: 'technicalInformation',
        graphQlLink: 'technicalInformation',
        noOrderBy: true,
        noDisplay: true,
      },
    ],
  },
  {
    name: 'Tickets',
    apiRequest: '/api/ticket/',
    routing: '/dashboard/tickets/',
    graphQl: 'tickets',
    columns: [
      {
        model: 'subject',
        label: 'Sujet',
        type: 'text',
        graphQlArgument: 'subject',
        graphQlLink: 'subject',
      },
      {
        model: 'criticity',
        label: 'Criticité',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'criticities',
        graphQlLink: 'criticity',
        dataFile: 'data_criticity',
        picklistLabel: 'fr',
      },
      {
        model: 'priority',
        label: 'Priorité',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'priorities',
        graphQlLink: 'priority',
        dataFile: 'data_priority',
        picklistLabel: 'fr',
      },
      {
        model: 'domain',
        label: 'Domaine',
        objectLink: 'domain.name',
        apiRequest: '/api/domains/',
        graphQlRequest: '{ domains{id, name} }',
        picklistLabel: 'name',
        dataReturn: 'domains',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'domainIds',
        graphQlLink: 'domain{ name} ',
        noOrderBy: true,
      },
      {
        model: 'stateId',
        label: 'Etat',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'states',
        graphQlLink: 'stateId',
        dataFile: 'data_ticket_state',
        picklistLabel: 'fr',
      },
      {
        model: 'createdAt',
        label: 'Date création',
        type: 'date',
        graphQlArgument: 'createdAt',
        graphQlLink: 'createdAt',
      },
      {
        model: 'closingDate',
        label: 'Date cloture',
        type: 'date',
        graphQlArgument: 'closingDate',
        graphQlLink: 'closingDate',
      },
      {
        model: 'creator',
        label: 'Créateur',
        objectLink: 'creator.fullname',
        apiRequest: '/api/employee/',
        graphQlRequest: '{ employees{ id, fullname } }',
        picklistLabel: 'fullname',
        dataReturn: 'employees',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'creatorIds',
        graphQlLink: 'creator{ username }',
        noOrderBy: true,
      },
      {
        model: 'supportEmployee',
        label: 'Technicien',
        objectLink: 'supportEmployee.fullname',
        apiRequest: '/api/employee/',
        graphQlRequest: '{ employees{ id, fullname } }',
        picklistLabel: 'fullname',
        dataReturn: 'employees',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'supportEmployeeIds',
        graphQlLink: 'supportEmployee{ username }',
        noOrderBy: true,
      },
      {
        model: 'site',
        label: 'Compte',
        routing: '/dashboard/sites/',
        objectLink: 'site.installationSite.socialReason',
        apiRequest: '/api/searchBar/',
        graphQlSearch: '{ customers(search:"$search"){ id, installationSite{ socialReason } } }',
        picklistLabel: 'label',
        picklistComposition: ['installationSite', 'socialReason'],
        isSophisticated: true,
        dataReturn: 'customers',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'customersIds',
        graphQlLink: 'site{ id, socialReason }',
        noOrderBy: true,
      },
      {
        model: 'associatedContact',
        label: 'Contact',
        routing: '/dashboard/contacts/',
        objectLink: 'customer.associatedContact.lastname',
        picklistLabel: 'lastname',
        type: 'picklist',
        multi: true,
        graphQlLink: 'associatedContact{ id, lastname}',
        noFilter: true,
        noOrderBy: true,
      },
      {
        model: 'urlSupplierTicket',
        label: 'Url ticket fournisseur',
        type: 'text',
        graphQlArgument: 'urlSupplierTicket',
        graphQlLink: 'urlSupplierTicket',
      },
      {
        model: 'closedReason',
        label: 'Raison cloture',
        objectLink: 'closedReason.label',
        apiRequest: '/api/ticket/getReasonsOfClosing/',
        graphQlRequest: '{ ticketClosedReasons{ id, label } }',
        picklistLabel: 'label',
        dataReturn: 'ticketClosedReasons',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'closedReasonIds',
        graphQlLink: 'closedReason{ label }',
        noOrderBy: true,
      },
      {
        model: 'closed',
        label: 'Cloturé',
        type: 'boolean',
        graphQlArgument: 'closed',
        graphQlLink: 'closed',
        noOrderBy: true,
      },
      {
        model: 'supplierOfProduct',
        label: 'Fournisseur',
        objectLink: 'supplierOfProduct.name',
        apiRequest: '/api/supplierVirtual/',
        graphQlRequest: '{ suppliersVirtual{ id, name } }',
        picklistLabel: 'name',
        dataReturn: 'suppliersVirtual',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'supplierOfProductIds',
        graphQlLink: 'supplierOfProduct{ name }',
        noOrderBy: true,
      },
      {
        model: 'type',
        label: "Type d'incident",
        objectLink: 'incidentType.name',
        apiRequest: '/api/incidentType/',
        graphQlRequest: '{ incidentTypes{ id, name } }',
        picklistLabel: 'name',
        dataReturn: 'incidentTypes',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'incidentTypeIds',
        graphQlLink: 'type',
        noOrderBy: true,
      },
      {
        model: 'productType',
        label: 'Type de produit',
        objectLink: 'productType.name',
        apiRequest: '/api/dealType/',
        graphQlRequest: '{ dealTypes{ id, name } }',
        picklistLabel: 'name',
        dataReturn: 'dealTypes',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'productTypeIds',
        graphQlLink: 'productType{ name }',
        noOrderBy: true,
      },
    ],
  },
  {
    name: 'Contacts',
    apiRequest: '/api/contact/',
    routing: '/dashboard/contact/',
    graphQl: 'contacts',
    columns: [
      {
        model: 'name',
        label: 'Prénom',
        type: 'text',
        graphQlArgument: 'name',
        graphQlLink: 'name',
      },
      {
        model: 'lastname',
        label: 'Nom',
        type: 'text',
        graphQlArgument: 'lastname',
        graphQlLink: 'lastname',
      },
      {
        model: 'job',
        label: 'Job',
        type: 'text',
        graphQlArgument: 'job',
        graphQlLink: 'job',
      },
      {
        model: 'companyName',
        label: 'Nom entreprise',
        type: 'text',
        graphQlArgument: 'companyName',
        graphQlLink: 'companyName',
      },
      {
        model: 'email',
        label: 'Email',
        type: 'text',
        graphQlArgument: 'email',
        graphQlLink: 'email',
      },
      {
        model: 'phoneNumber',
        label: 'Téléphone',
        type: 'text',
        graphQlArgument: 'phoneNumber',
        graphQlLink: 'phoneNumber',
      },
      {
        model: 'dateCreate',
        label: 'Date création',
        type: 'date',
        graphQlArgument: 'dateCreate',
        graphQlLink: 'dateCreate',
      },
      {
        model: 'creator',
        label: 'Créateur',
        objectLink: 'creator.fullname',
        apiRequest: '/api/employee/',
        graphQlRequest: '{ employees{ id, fullname } }',
        picklistLabel: 'fullname',
        dataReturn: 'employees',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'creatorIds',
        graphQlLink: 'creator{ user{username} }',
        noOrderBy: true,
      },
      {
        model: 'customer',
        label: 'Compte',
        routing: '/dashboard/customer/',
        objectLink: 'customer.installationSite.socialReason',
        apiRequest: '/api/searchBar/',
        graphQlSearch: '{ customers(search:$search){ id, installationSite{ socialReason } } }',
        picklistLabel: 'label',
        picklistComposition: ['installationSite', 'socialReason'],
        isSophisticated: true,
        dataReturn: 'customers',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'customersIds',
        graphQlLink: 'customer{ id, installationSite{ socialReason }}',
        noOrderBy: true,
      },
      {
        model: 'origin',
        label: 'Origine',
        objectLink: 'origin.labelOrigin',
        apiRequest: '/api/origin/',
        graphQlRequest: '{ origins{id, labelOrigin} }',
        picklistLabel: 'labelOrigin',
        dataReturn: 'origins',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'originIds',
        graphQlLink: 'origin{ labelOrigin} ',
        noOrderBy: true,
      },
    ],
  },
  {
    name: 'Rappels',
    apiRequest: '/api/reminder/',
    routing: '/dashboard/reminder/',
    graphQl: 'reminders',
    columns: [
      {
        model: 'title',
        label: 'Titre',
        type: 'text',
        graphQlArgument: 'title',
        graphQlLink: 'title',
      },
      {
        model: 'criticity',
        label: 'Criticité',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'criticities',
        graphQlLink: 'criticity',
        dataFile: 'data_criticity',
        picklistLabel: 'fr',
      },
      {
        model: 'priority',
        label: 'Priorité',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'priorities',
        graphQlLink: 'priority',
        dataFile: 'data_priority',
        picklistLabel: 'fr',
      },
      {
        model: 'state',
        label: 'Etat',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'states',
        graphQlLink: 'state',
        dataFile: 'data_task_state',
        picklistLabel: 'fr',
      },
      {
        model: 'dateCreate',
        label: 'Date création',
        type: 'date',
        graphQlArgument: 'dateCreate',
        graphQlLink: 'dateCreate',
      },
      {
        model: 'dateRecall',
        label: 'Date rappel',
        type: 'date',
        graphQlArgument: 'dateRecall',
        graphQlLink: 'dateRecall',
      },
      {
        model: 'closed',
        label: 'Clos',
        type: 'boolean',
        graphQlArgument: 'closedDashlet',
        graphQlLink: 'closed',
        noOrderBy: true,
      },
      {
        model: 'closingDate',
        label: 'Date cloture',
        type: 'date',
        graphQlArgument: 'closingDate',
        graphQlLink: 'closingDate',
      },
      {
        model: 'deal',
        routing: '/dashboard/deal/',
        label: 'Affaire',
        objectLink: 'deal.name',
        type: 'picklist',
        multi: true,
        graphQlLink: 'deal { id, name }',
        noFilter: true,
        noOrderBy: true,
      },
      {
        model: 'ticket',
        label: 'Ticket',
        routing: '/dashboard/tickets/',
        objectLink: 'ticket.subject',
        type: 'picklist',
        multi: true,
        graphQlLink: 'ticket { id, subject }',
        noFilter: true,
        noOrderBy: true,
      },
      {
        model: 'contact',
        label: 'Contact',
        routing: '/dashboard/contact/',
        objectLink: 'contact.name',
        type: 'picklist',
        multi: true,
        graphQlLink: 'contact { id, lastname }',
        noFilter: true,
        noOrderBy: true,
      },
      {
        model: 'customer',
        label: 'Compte',
        routing: '/dashboard/customer/',
        objectLink: 'customer.installationSite.socialReason',
        apiRequest: '/api/searchBar/',
        graphQlSearch: '{ customers(search:$search){ id, installationSite{ socialReason } } }',
        picklistLabel: 'label',
        picklistComposition: ['installationSite', 'socialReason'],
        isSophisticated: true,
        dataReturn: 'customers',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'customersIds',
        graphQlLink: 'customer{ id, installationSite{ socialReason }}',
        noOrderBy: true,
      },
      {
        model: 'creator',
        label: 'Créateur',
        objectLink: 'creator.fullname',
        apiRequest: '/api/employee/',
        graphQlRequest: '{ employees{ id, fullname } }',
        picklistLabel: 'fullname',
        dataReturn: 'employees',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'creatorIds',
        graphQlLink: 'creator{ user{username} }',
        noOrderBy: true,
      },
      {
        model: 'assignedEmployee',
        label: 'Employé associé',
        objectLink: 'assignedEmployee.fullname',
        apiRequest: '/api/employee/',
        graphQlRequest: '{ employees{ id, fullname } }',
        picklistLabel: 'fullname',
        dataReturn: 'employees',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'assignedEmployeeIds',
        graphQlLink: 'assignedEmployee{ user{username} }',
        noOrderBy: true,
      },
    ],
  },
  {
    name: 'Rendez-vous',
    apiRequest: '/api/appointment/',
    routing: '/dashboard/appointment/',
    graphQl: 'appointments',
    columns: [
      {
        model: 'title',
        label: 'Titre',
        type: 'text',
        graphQlArgument: 'title',
        graphQlLink: 'title',
      },
      {
        model: 'dateMeeting',
        label: 'Date',
        type: 'date',
        graphQlArgument: 'dateMeeting',
        graphQlLink: 'dateMeeting',
      },
      {
        model: 'duration',
        label: 'Durée',
        type: 'numeric',
        graphQlArgument: 'duration',
        graphQlLink: 'duration',
      },
      {
        model: 'place',
        label: 'Lieu',
        type: 'text',
        graphQlArgument: 'duration',
        graphQlLink: 'duration',
      },
      {
        model: 'criticity',
        label: 'Criticité',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'criticities',
        graphQlLink: 'criticity',
        dataFile: 'data_criticity',
        picklistLabel: 'fr',
      },
      {
        model: 'priority',
        label: 'Priorité',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'priorities',
        graphQlLink: 'priority',
        dataFile: 'data_priority',
        picklistLabel: 'fr',
      },
      {
        model: 'dateCreate',
        label: 'Date création',
        type: 'date',
        graphQlArgument: 'dateCreate',
        graphQlLink: 'dateCreate',
      },
      {
        model: 'closed',
        label: 'Clos',
        type: 'boolean',
        graphQlArgument: 'closedDashlet',
        graphQlLink: 'closed',
        noOrderBy: true,
      },
      {
        model: 'closingDate',
        label: 'Date cloture',
        type: 'date',
        graphQlArgument: 'closingDate',
        graphQlLink: 'closingDate',
        noOrderBy: true,
      },
      {
        model: 'creator',
        label: 'Créateur',
        routing: '/dashboard/user/',
        objectLink: 'creator.fullname',
        apiRequest: '/api/employee/',
        graphQlRequest: '{ employees{ id, fullname } }',
        picklistLabel: 'fullname',
        dataReturn: 'employees',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'creatorIds',
        graphQlLink: 'creator{ user{username} }',
        noOrderBy: true,
      },
      {
        model: 'deal',
        label: 'Affaire',
        routing: '/dashboard/deal/',
        objectLink: 'deal.name',
        type: 'picklist',
        multi: true,
        graphQlLink: 'deal { id, name }',
        noFilter: true,
        noOrderBy: true,
      },
      {
        model: 'ticket',
        label: 'Ticket',
        routing: '/dashboard/tickets/',
        objectLink: 'ticket.subject',
        type: 'picklist',
        multi: true,
        graphQlLink: 'ticket { id, subject }',
        noFilter: true,
        noOrderBy: true,
      },
      {
        model: 'contact',
        label: 'Contact',
        routing: '/dashboard/contact/',
        objectLink: 'contact.name',
        type: 'picklist',
        multi: true,
        graphQlLink: 'contact { id , lastname }',
        noFilter: true,
        noOrderBy: true,
      },
      {
        model: 'customer',
        label: 'Compte',
        routing: '/dashboard/customer/',
        objectLink: 'customer.installationSite.socialReason',
        apiRequest: '/api/searchBar/',
        graphQlSearch: '{ customers(search:$search){ id, installationSite{ socialReason } } }',
        picklistLabel: 'label',
        picklistComposition: ['installationSite', 'socialReason'],
        isSophisticated: true,
        dataReturn: 'customers',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'customersIds',
        graphQlLink: 'customer{ id, installationSite{ socialReason }}',
        noOrderBy: true,
      },
      {
        model: 'employeesConcerned',
        label: 'Employés concernés',
        routing: '/dashboard/user/',
        objectLink: 'employee.fullname',
        apiRequest: '/api/employee/',
        graphQlRequest: '{ employees{ id, fullname } }',
        picklistLabel: 'fullname',
        dataReturn: 'employees',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'employeesConcernedIds',
        graphQlLink: 'employeesConcerned{ user{username} }',
        noDisplay: true,
        noOrderBy: true,
      },
      {
        model: 'appointmentType',
        label: 'Type de rendez-vous',
        objectLink: 'appointmentType.name',
        apiRequest: '/api/appointment/getAppointmentTypes/',
        graphQlRequest: '{ appointmentTypes{ id, name } }',
        picklistLabel: 'name',
        dataReturn: 'appointmentTypes',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'appointmentTypeIds',
        graphQlLink: 'appointmentType{ name }',
        noOrderBy: true,
      },
    ],
  },
  {
    name: 'Tâches',
    apiRequest: '/api/task/',
    routing: '/dashboard/task/',
    graphQl: 'tasks',
    columns: [
      {
        model: 'title',
        label: 'Titre',
        type: 'text',
        graphQlArgument: 'title',
        graphQlLink: 'title',
      },
      {
        model: 'criticity',
        label: 'Criticité',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'criticities',
        graphQlLink: 'criticity',
        dataFile: 'data_criticity',
        picklistLabel: 'fr',
      },
      {
        model: 'priority',
        label: 'Priorité',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'priorities',
        graphQlLink: 'priority',
        picklistLabel: 'fr',
      },
      {
        model: 'state',
        label: 'Etat',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'states',
        graphQlLink: 'state',
        dataFile: 'data_task_state',
        picklistLabel: 'fr',
      },
      {
        model: 'dateCreate',
        label: 'Date création',
        type: 'date',
        graphQlArgument: 'dateCreate',
        graphQlLink: 'dateCreate',
      },
      {
        model: 'deadline',
        label: 'Date limite',
        type: 'date',
        graphQlArgument: 'deadline',
        graphQlLink: 'deadline',
      },
      {
        model: 'closed',
        label: 'Clos',
        type: 'boolean',
        graphQlArgument: 'closedDashlet',
        graphQlLink: 'closed',
        noOrderBy: true,
      },
      {
        model: 'closingDate',
        label: 'Date cloture',
        type: 'date',
        graphQlArgument: 'closingDate',
        graphQlLink: 'closingDate',
      },
      {
        model: 'creator',
        label: 'Créateur',
        routing: '/dashboard/user/',
        objectLink: 'creator.fullname',
        apiRequest: '/api/employee/',
        graphQlRequest: '{ employees{ id, fullname } }',
        picklistLabel: 'fullname',
        dataReturn: 'employees',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'creatorIds',
        graphQlLink: 'creator{ user{username} }',
        noOrderBy: true,
      },
      {
        model: 'deal',
        routing: '/dashboard/deal/',
        label: 'Affaire',
        objectLink: 'deal.name',
        type: 'picklist',
        multi: true,
        graphQlLink: 'deal { id, name }',
        noFilter: true,
        noOrderBy: true,
      },
      {
        model: 'ticket',
        label: 'Ticket',
        routing: '/dashboard/tickets/',
        objectLink: 'ticket.subject',
        type: 'picklist',
        multi: true,
        graphQlLink: 'ticket { id, subject }',
        noFilter: true,
        noOrderBy: true,
      },
      {
        model: 'contact',
        label: 'Contact',
        routing: '/dashboard/contact/',
        objectLink: 'contact.name',
        type: 'picklist',
        multi: true,
        graphQlLink: 'contact { id, lastname }',
        noFilter: true,
        noOrderBy: true,
      },
      {
        model: 'customer',
        label: 'Compte',
        routing: '/dashboard/customer/',
        objectLink: 'customer.installationSite.socialReason',
        apiRequest: '/api/searchBar/',
        graphQlSearch: '{ customers(search:$search){ id, installationSite{ socialReason } } }',
        picklistLabel: 'label',
        picklistComposition: ['installationSite', 'socialReason'],
        isSophisticated: true,
        dataReturn: 'customers',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'customersIds',
        graphQlLink: 'customer{ id, installationSite{ socialReason }}',
        noOrderBy: true,
      },
      {
        model: 'employeesConcerned',
        label: 'Employés concernés',
        routing: '/dashboard/user/',
        objectLink: 'employee.fullname',
        apiRequest: '/api/employee/',
        graphQlRequest: '{ employees{ id, fullname } }',
        picklistLabel: 'fullname',
        dataReturn: 'employees',
        type: 'picklist',
        multi: true,
        graphQlArgument: 'employeesConcernedIds',
        graphQlLink: 'employeesConcerned{ user{username} }',
        noDisplay: true,
        noOrderBy: true,
      },
    ],
  },
];

export default modules;
